<template>
  <el-dialog
    title="添加电子运单"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
    style="margin-top: -5%;"
  >
    <div class="product-add pb50">
      <el-form 
        ref="formRef" 
        :model="form" 
        :rules="rules" 
        label-width="120px"
        size="small"
      >
        <!-- <el-row :gutter="20">
          <el-col :span="12">
             <el-form-item label="检查项" prop="electronic_waybill_item_id">
              <el-select 
                v-model="form.electronic_waybill_item_id" 
                placeholder="请选择检查项"
                style="width: 100%;"
                clearable
                filterable
              >
                <el-option
                  v-for="dept in itemList"
                  :key="dept.electronic_waybill_item_id"
                  :label="dept.name"
                  :value="dept.electronic_waybill_item_id"
                />
              </el-select>
            </el-form-item> 
          </el-col>
           <el-col :span="12">
            <el-form-item label="管理方式" prop="type" required>
              <el-radio-group v-model="form.type">
                <el-radio :label="1">线上</el-radio>
                <el-radio :label="0">线下</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="驾驶时间" prop="ew_time" required>
              <div class="block">
                <el-date-picker
                  size="small"
                  v-model="form.ew_time"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="文件上传" prop="certificate_w" required>
              <el-button icon="el-icon-picture-outline" @click="openFileUpload">选择文件</el-button>
         
              <div v-if="uploadStatus === 'success'" style="color: #67C23A; font-size: 12px; margin-top: 5px;">
                {{ form.certificate_w }}
              </div>
              <div v-if="uploadStatus === 'error'" style="color: #F56C6C; font-size: 12px; margin-top: 5px;">
                文件上传失败，请重新上传
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="其它凭证" prop="certificate_img">
          <div class="draggable-list">
            <draggable v-model="form.certificate_img" class="wrapper" :options="{ animation: 150 }">
              <transition-group>
                <div v-for="(item, index) in form.certificate_img" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="凭证图片"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openUpload()">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item> -->
        
        <el-form-item prop="info" label="出车记录">
          <el-input 
            v-model="form.info" 
            type="textarea"
            :rows="9"
            placeholder="请输入出车记录内容"
            maxlength="2000"
            show-word-limit
          />
        </el-form-item>
        
        <el-form-item prop="trajectory" label="跑的路线">
          <el-input 
            v-model="form.trajectory" 
            type="textarea"
            :rows="9"
            placeholder="请输入跑的路线"
            maxlength="2000"
            show-word-limit
          />
        </el-form-item>
        
        <div class="common-button-wrapper" style="text-align: center; margin-top: 30px;">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      
      <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
      <Upload v-if="isuploadFile" :isupload="isuploadFile" @returnImgs="returnFilesFunc">上传文件</Upload>
    </div>
  </el-dialog>
</template>

<script>
import AfuncApi from '@/api/afunc.js'
import Upload from '@/components/file/Upload'
import draggable from 'vuedraggable'

export default {
  name: 'ElectronicWaybillAdd', // Vue2推荐声明组件名
  components: {
    Upload,
    draggable
  },
  props: {
    open_add: { // Vue2推荐显式声明prop类型
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isupload: false,
      isuploadFile:false,
      uploading: false, // 上传中状态
      activeType: '0',
      dialogVisible: false,
      isProductUpload: false,
      uploadType: 'image',
      loading: false,
      uploadStatus: '',
      isFileUploaded: false,
      
      // 下拉列表数据
      itemList: [],
      positionList: [],
      
      // 表单数据
      form: {
        electronic_waybill_item_id: '', 
        type: '', 
        info: '',
        ew_time: '',
        certificate_img: [],
        certificate_w: ''
      },
      // 修改 rules 部分
      rules: {
        // electronic_waybill_item_id: [
        //   { 
        //     required: true, 
        //     message: '请选择检查项', 
        //     trigger: ['change', 'blur']  // 添加 blur 触发
        //   }
        // ],
        // type: [
        //   { 
        //     required: true, 
        //     message: '请选择管理方式', 
        //     trigger: ['change', 'blur'] 
        //   }
        // ],
        ew_time: [
          { 
            required: true, 
            message: '请选择记录时间', 
            trigger: ['change', 'blur'] 
          }
        ],
        certificate_w: [
          { 
            required: true, 
            message: '请上传文件', 
            trigger: ['change', 'blur'] 
          }
        ]
      }  
    }
  },
  created() {
    this.dialogVisible = this.open_add
    this.initForm()
    this.loadElectronicWaybill()
  },
  methods: {
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        console.log(e,'eadd')
        this.form.certificate_img = this.form.certificate_img.concat(e)
      }
      this.isupload = false;
    },
    returnFilesFunc(e) {
      this.uploadStatus = ''
      if (e != null && e.length > 0) {
        this.form.certificate_w = e[0].file_path;
        this.uploadStatus = 'success'
        this.isFileUploaded = true;
        this.$nextTick(() => {
          this.$refs.formRef.validateField('certificate_w')
        })
      }
      this.isuploadFile = false;
    },
    // 初始化表单
    initForm() {
      this.form = {
        electronic_waybill_item_id: '', 
        type: '', 
        info: '',
        trajectory:'',
        ew_time: '',
        certificate_img: [],
        certificate_w: ''
      }
      this.isFileUploaded = false
      this.uploadStatus = ''
      this.uploading = false
      
      // 修复点5：使用$nextTick确保formRef已挂载后再清空校验
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    // 加载检查项列表
    async loadElectronicWaybill() {
      try {
        const response = await AfuncApi.call({
          model: 'electronic_waybill_item',
          action: 'index',
          page: 1,
          list_rows: 1000
        })
        
        if (response.code === 1 && response.data.list) {
          this.itemList = response.data.list.data || []
        }
      } catch (error) {
        console.error('加载检查项列表失败:', error)
        this.$message.error('加载检查项列表失败')
      }
    },
    // 打开图片上传组件
    openUpload() {
      this.isupload = true;
    },
    openFileUpload() {
      this.isuploadFile = true;
    },
    // 删除图片
    deleteImg(index,) {
      this.form.certificate_img.splice(index, 1)
    },
    // 关闭弹窗
    dialogFormVisible() {
      this.$emit("close", { openDialog: false })
    },
    // 取消按钮
    cancelFunc() {
      this.dialogFormVisible()
    },
    // 提交表单
    async onSubmit() {
      try {
        // Vue2表单校验
        await this.$refs.formRef.validate()
      } catch (error) {
        return // 校验失败则返回
      }
      
      try {
        this.loading = true
        
        // 处理表单数据
        const formData = {
          ...this.form
        }

        // 调用新增接口
        const response = await AfuncApi.call({
          model: 'electronic_waybill',
          action: 'add',
          ...formData
        })
        
        if (response.code === 1) {
          this.$message.success(response.msg || '添加成功')
          this.dialogFormVisible()
        } else {
          this.$message.error(response.msg || '添加失败')
        }
      } catch (error) {
        console.error('添加失败:', error)
        this.$message.error('添加失败')
      } finally {
        this.loading = false
      }
    },
    // 刷新列表
    getTableList() {
      this.$emit('refreshList')
    }
  }
}
</script>

<style scoped>
.pb50 {
  padding-bottom: 50px;
}

.upload-section {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 10px;
  background: #F5F7FA;
  margin-bottom: 15px;
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.image-item {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  overflow: hidden;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  padding: 2px;
}

.upload-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}

.common-button-wrapper {
  margin-top: 20px;
  text-align: center;
}

.el-row {
  margin-bottom: 15px;
}

.el-form-item {
  margin-bottom: 15px;
}

/* Vue2深度选择器（替换::v-deep） */
/deep/ .el-textarea__inner {
  font-family: inherit;
  line-height: 1.5;
}

/deep/ .el-tabs__item {
  padding: 0 20px;
}

/deep/ .el-tabs__header {
  margin-bottom: 15px;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px;
}

/* 拖拽样式 */
.draggable-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.draggable-list .item {
  width: 80px;
  height: 80px;
  border: 1px dashed #DCDFE6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.draggable-list .item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.draggable-list .item .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(245, 108, 108, 0.8);
  color: #fff;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
}

.draggable-list .img-select {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/electronic_waybill/index/part/add.vue